function validFile(file) {
  if (
    !file ||
    typeof file !== 'object' ||
    file.isDir ||
    (file.name != null && typeof file.name !== 'string') ||
    typeof file.link !== 'string' ||
    !file.link.trim()
  ) {
    return false
  }
  try {
    const url = new URL(file.link)
    if (
      url.protocol !== 'https:' ||
      url.username ||
      url.password ||
      url.port ||
      !(url.hostname === 'dropbox.com' || url.hostname.endsWith('.dropbox.com'))
    ) {
      return false
    }
    return url.href
  } catch (error) {
    return false
  }
}

export function buildDropboxLinksHtml(files) {
  if (!Array.isArray(files)) return { html: '', skippedCount: 0 }
  if (typeof document === 'undefined') {
    return { html: '', skippedCount: files.length }
  }
  const links = []
  let skippedCount = 0
  files.forEach(file => {
    const href = validFile(file)
    if (!href) {
      skippedCount += 1
      return
    }
    const anchor = document.createElement('a')
    anchor.textContent =
      typeof file.name === 'string' && file.name.trim()
        ? file.name
        : 'Dropbox file'
    anchor.href = href
    links.push(anchor.outerHTML)
  })
  return { html: links.join('<br>'), skippedCount }
}

export default buildDropboxLinksHtml
